<template>
  <div class="home-div">
    <SideBar style="z-index: 9999" />
    <div class="content">
      <div class="left">
        <div v-if="lifeInfo === undefined" class="info-tip font-color-1">
          正在加载中，请稍后~
        </div>
        <div v-else class="info mbl-no-hover slide-in-left">
          <div class="md-div font-color-1">
            <div class="md-title">{{ lifeInfo.title }}</div>
            <div class="md-img-div">
              <div class="md-img-item">
                <img class="md-img" src="@/assets/icon/icon-2.png" />{{
                  lifeInfo.userName
                }}
              </div>
              <div class="md-img-item">
                <img class="md-img" src="@/assets/icon/icon-1.png" />{{
                  displayDate(lifeInfo.createdTime)
                }}
              </div>
              <div class="md-img-item">
                <img class="md-img" src="@/assets/icon/icon-y.png" />{{
                  lifeInfo.typeName
                }}
              </div>
              <!-- 新增分享按钮 -->
              <div class="md-img-item share-btn" @click="openSharePoster(lifeInfo)">
                <img class="md-img" src="@/assets/icon/share.png" />
              </div>
            </div>
          </div>
          <mavon-editor v-model="lifeInfo.content" :subfield="false" :defaultOpen="'preview'" :toolbarsFlag="false"
            :xssOptions="false" :editable="false" style="height: auto !important"
            :previewBackground="'background-color: rgba(255, 255, 255, 0) !important'" :ishljs="true"
            :imageClick="handleMavonImgClick" class="md-editor font-color-1" />
          <div class="md-img-div" style="margin-bottom: 10px !important; cursor: pointer"
            @click="openLifeComment(lifeInfo.id, lifeInfo.title)">
            <div class="md-img-item font-color-1">
              <img class="md-img" src="@/assets/icon/icon-7.png" />写留言，共{{
                lifeInfo.commCount
              }}条留言
            </div>
          </div>
        </div>
      </div>
    </div>
    <BottomTip style="padding-top: 50px" />
    <!-- 全屏图片预览模态框 -->
    <div v-if="isFullscreen" class="fullscreen-overlay" @click.self="closeFullscreen">
      <div class="fullscreen-content">
        <img :src="currentFullscreenImage" class="fullscreen-image" @click="closeFullscreen" />
        <!-- <button class="close-btn" @click="closeFullscreen">×</button> -->
      </div>
    </div>
    <div v-if="showLifeComment" class="comment-mask">
      <div class="comments-container mbl-no-hover">
        <div class="cm-title font-color-1">留言板：{{ commLifeTitle }}</div>
        <div class="comment-form">
          <textarea class="bgc font-color-1" v-model="newComment" placeholder="留言内容..." rows="5"></textarea>
          <input class="bgc font-color-1" v-model="newName" placeholder="昵称必填！" style="width: 200px" maxlength="20" />
          <input class="bgc font-color-1" v-model="commEmail" placeholder="邮箱（选填）" style="width: 240px" />
          <button @click="submitComment" class="submit-btn bgc font-color-1">
            发送留言
          </button>
        </div>

        <div class="comments-list" style="color: #ffffff">
          <div v-for="comment in comments" :key="comment.id" class="bgc font-color-1"
            style="border-radius: 5px; margin-bottom: 5px; padding-bottom: 10px">
            <div class="comment-header">
              <img src="@/assets/live2d-photo.png" class="user-avatar" alt="用户头像" />
              <span class="username font-color-1">{{ comment.userName }}</span>
              <span class="comment-time font-color-4">{{
                displayDate(comment.createdTime)
              }}</span>
              <button @click="showReplyBox(comment)" class="reply-btn font-color-1">
                回复
              </button>
            </div>
            <div class="comment-content font-color-4">{{ comment.qsInfo }}</div>

            <!-- 显示子评论数量和加载状态 -->
            <div class="replies-info" v-if="comment.replyCount > 0">
              <span class="reply-count ont-color-1" @click="loadReplies(comment)">
                共 {{ comment.replyCount }} 条回复，点击查看
                <span v-if="comment.loadingReplies" class="loading-text font-color-1">加载中...</span>
              </span>
            </div>

            <!-- 一级回复 -->
            <div v-if="comment.replies && comment.replies.length > 0" class="replies-container">
              <div v-for="reply in comment.replies" :key="reply.id" class="reply-item">
                <div class="reply-header">
                  <img src="@/assets/live2d-photo.png" class="user-avatar" alt="用户头像" />
                  <span class="username">{{ reply.userName }}</span>
                  <span class="reply-time">{{
                    displayDate(comment.createdTime)
                  }}</span>
                  <button @click="showReplyBox(comment, reply)" class="reply-btn font-color-1">
                    回复
                  </button>
                </div>
                <div class="reply-content">
                  {{ reply.qsInfo }}
                </div>
              </div>

              <!-- 二级评论加载更多 -->
              <div v-if="comment.hasMoreReplies" class="load-more-replies">
                <button @click="loadMoreReplies(comment)" class="submit-btn bgc font-color-1">
                  {{ comment.loadingMore ? "加载中..." : "加载更多回复" }}
                </button>
              </div>
            </div>

            <!-- 回复框 -->
            <div v-if="activeReplyBox === comment.id" class="reply-box">
              <textarea class="bgc font-color-1" v-model="replyContent" :placeholder="`@${comment.userName} `"
                ref="replyTextarea"></textarea>
              <div class="comment-form">
                <input class="bgc font-color-1" v-model="newName" placeholder="昵称必填" style="width: 200px"
                  maxlength="20" />
                <input class="bgc font-color-1" v-model="commEmail" placeholder="邮箱（选填）" style="width: 240px" />
                <button @click="submitReply(comment)" class="submit-btn bgc font-color-1">
                  回复
                </button>
                <button @click="cancelReply" class="cancel-btn bgc font-color-1">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- 滚动加载提示 -->
        <div v-if="loading" class="loading-more font-color-1">加载中...</div>
        <div v-if="hasMore" class="load-more-hint ont-color-1" @click="loadMoreComments">
          点击加载更多顶级留言
        </div>
        <div v-if="!hasMore && comments.length > 0" class="no-more font-color-1">
          没有更多顶级留言了
        </div>
        <div class="load-more-replies">
          <button class="submit-btn bgc font-color-1" @click="closeLifeComment">
            关闭留言版
          </button>
        </div>
      </div>
    </div>
    
    <!-- 分享海报弹窗 -->
    <div v-if="showShareModal" class="share-modal-mask" @click.self="closeShareModal">
      <div class="share-modal-box">
        <!-- 海报DOM，用于html2canvas截图 -->
        <div ref="posterDom" class="poster-card">
          <!-- 固定标题 -->
          <div class="poster-title-main">了栀·风与异乡人</div>
          <!-- 文章标题 -->
          <div class="poster-article-title">
            「{{ currentShareItem.title }}」
          </div>
          <!-- 正文第一张图 -->
          <div class="poster-img-wrap" v-if="posterFirstImg">
            <img :src="posterFirstImg" class="poster-img" />
          </div>
          <div v-else class="poster-img-empty">暂无配图</div>
          <!-- 文字摘要 -->
          <div class="poster-desc">{{ posterSummary }}</div>
          <!-- 草料二维码 -->
          <div class="poster-qrcode">
            <img :src="qrCodeUrl" alt="访问二维码" />
          </div>
        </div>
        <!-- 操作按钮 -->
        <div class="share-btn-group">
          <button @click="downloadPoster" class="download-btn">下载海报</button>
          <button @click="closeShareModal" class="close-btn">关闭</button>
        </div>
      </div>
    </div>
    <!-- 微信长按保存专用遮罩 -->
    <div v-if="showWechatSaveMask" class="wechat-save-mask" @click.self="showWechatSaveMask = false">
      <div class="tip-text">长按图片保存到相册</div>
      <img :src="posterDataUrl" class="save-poster-img" />
      <div class="close-tip">点击空白关闭</div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import SideBar from "@/components/menu/SideBar.vue";
import BottomTip from "@/components/menu/BottomTip.vue";
import TimesView from "@/components/tip/TimesView.vue";
import Weather from "@/components/Weather.vue";
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";
import Pagination from "@/components/Pagination.vue";
import { Message } from "element-ui";

import { getUserInfo } from "@/api/home";
import config from "@/utils/Config";
import router from "@/router";
import {
  getLifeDetail
} from "@/api/life.js";
import { saveCommentsData, getQsList, getRecentQsList } from "@/api/comments";

export default {
  name: "LifeDetail",
  components: {
    SideBar,
    BottomTip,
    TimesView,
    Weather,
    mavonEditor,
    Pagination,
  },
  data() {
    return {
      typeId: "",
      tags: [],
      colors: [
        "#4ECDC4",
        "#45B7D1",
        "#96CEB4",
        "#FF6B6B",
        "#DDA0DD",
        "#98D8C8",
        "#6C5CE7",
        "#BB8FCE",
        "#85C1E9",
      ],
      baseFileUrl: config.BASE_FILE_URL,
      isFullscreen: false,
      currentFullscreenImage: "",
      screenHeight: document.documentElement.clientHeight + "px",
      archivesList: [],
      lifeInfo: {},
      lifeTime: "",
      showLifeComment: false,

      keyword: "",
      fieldName: "",
      pagination: {
        page: 1,
        limit: 3,
        totalSize: 0,
        totalPage: 0,
      },

      selectMonthValue: "",
      titleList: [],
      currCommentList: [],

      baseImgUrl: config.BASE_FILE_URL,
      milestoneList: [],
      // 用户默认属性
      UserInfo: {
        name: "",
        sign: "",
        nameEn: "",
        hometown: "",
        university: "",
        email: "",
      },

      // 评论相关
      newComment: "",
      newName: "",
      commEmail: "",
      id: -1,
      commLifeId: 0,
      commLifeTitle: "",
      replyContent: "",
      replyEmail: "",
      replyUserName: "",
      comments: [],
      activeReplyBox: null,
      currentReplyTo: null,
      showAllReplies: {},
      currentPage: 1,
      currentSize: 5,
      totalPages: 0,

      loading: false,
      hasMore: true,

      showShareModal: false,
      currentShareItem: null, // 当前分享的文章item
      posterFirstImg: "", // 正文第一张图片
      posterSummary: "", // 正文摘要
      qrCodeUrl: "", // 草料二维码链接
      // 下面两行新增
      posterDataUrl: "",
      showWechatSaveMask: false
    };
  },
  async mounted() {
    // 使用防抖优化resize事件
    this.debouncedResize = this.debounce(() => {
      this.screenHeight = document.documentElement.clientHeight + "px";
    }, 250);
    window.addEventListener("resize", this.debouncedResize);
    const id = this.$route.query.id;
    await this.loadPriorityData(id);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.debouncedResize);
    // document.removeEventListener('click', this.closePopoverOnClickOutside);
  },
  methods: {
    // 编辑器内部图片点击回调
handleMavonImgClick(imgDom) {
  this.currentFullscreenImage = imgDom.src;
  this.isFullscreen = true;
  document.body.style.overflow = "hidden";
},
    // 判断是否微信内置浏览器
    isWechatEnv() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.match(/micromessenger/) !== null;
    },
    // 打开分享海报弹窗
    openSharePoster(lifeInfo) {
      this.currentShareItem = lifeInfo;
      // 1. 拼接草料二维码链接，草料在线生成格式：https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=链接
      const targetUrl = `https://liaozhi.site/life-detail?id=${lifeInfo.id}`;
      this.qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=320x320&data=${encodeURIComponent(
        targetUrl
      )}`;

      // 2. 提取markdown内容里第一张图片
      this.extractFirstImage(lifeInfo.content);
      // 3. 生成文字摘要（截取前80字）
      this.posterSummary = this.getSummary(lifeInfo.content, 40);

      this.showShareModal = true;
    },
    // 关闭弹窗
    closeShareModal() {
      this.showShareModal = false;
      this.currentShareItem = null;
      this.posterFirstImg = "";
      this.posterSummary = "";
    },
    // 提取markdown中第一张图片链接
    extractFirstImage(mdText) {
      // 空内容直接置空
      if (!mdText) {
        this.posterFirstImg = "";
        return;
      }
      // 1. 优先匹配video标签封面
      const videoRegex = /<video.*?src=["'](.*?)["']/i;
      const videoMatch = mdText.match(videoRegex);
      if (videoMatch && videoMatch[1]) {
        let url = videoMatch[1].trim();
        if (
          url.startsWith("/") ||
          url.startsWith("./") ||
          url.startsWith("../")
        ) {
          url = this.baseFileUrl + url.replace(/^(\.\/|\.\.\/)/, "");
        }
        this.posterFirstImg = url;
        return;
      }
      // 2. 匹配markdown图片 ![]()
      const imgRegex = /!\[.*?\]\(([^)]+)\)/;
      const imgMatch = mdText.match(imgRegex);
      if (imgMatch && imgMatch[1]) {
        let url = imgMatch[1].trim();
        if (
          url.startsWith("/") ||
          url.startsWith("./") ||
          url.startsWith("../")
        ) {
          url = this.baseFileUrl + url.replace(/^(\.\/|\.\.\/)/, "");
        }
        this.posterFirstImg = url;
        return;
      }
      // 3. 匹配html原生<img>标签
      const htmlImgRegex = /<img.*?src=["'](.*?)["']/i;
      const htmlImgMatch = mdText.match(htmlImgRegex);
      if (htmlImgMatch && htmlImgMatch[1]) {
        let url = htmlImgMatch[1].trim();
        if (
          url.startsWith("/") ||
          url.startsWith("./") ||
          url.startsWith("../")
        ) {
          url = this.baseFileUrl + url.replace(/^(\.\/|\.\.\/)/, "");
        }
        this.posterFirstImg = url;
        return;
      }
      // 4. 无任何媒体图，置空（海报展示“暂无配图”）
      this.posterFirstImg = "";
    },
    // 提取纯文本摘要，去除markdown标签
    getSummary(mdText, maxLen) {
      if (!mdText) return "暂无内容";
      let text = mdText.replace(/```[\s\S]*?```/g, "");
      text = text.replace(/`.*?`/g, "");
      text = text.replace(/!\[.*?\]\(.*?\)/g, "");
      text = text.replace(/\[(.*?)\]\(.*?\)/g, "$1");
      text = text.replace(/^#{1,6}\s+/gm, "");
      text = text.replace(/(\*\*|__)(.*?)\1/g, "$2");
      text = text.replace(/(\*|_)(.*?)\1/g, "$2");
      text = text.replace(/~~(.*?)~~/g, "$1");
      text = text.replace(/<[^>]*>/g, "");
      text = text.replace(/^\s*>\s+/gm, "");
      text = text.replace(/^\s*[-*+]\s+/gm, "");
      text = text.replace(/^\s*\d+\.\s+/gm, "");
      text = text.replace(/^[-*_]{3,}$/gm, "");
      text = text.replace(/\s+/g, " ").trim();
      return text.length > maxLen ? text.substring(0, maxLen) + "..." : text;
    },
    // 下载海报（html2canvas转图片）
async downloadPoster() {
  try {
    const dom = this.$refs.posterDom;
    const imgList = dom.querySelectorAll("img");

    const restoreSrcList = [];
    const blobTasks = [];
    imgList.forEach((img) => {
      const originalSrc = img.src;
      restoreSrcList.push({ el: img, src: originalSrc });
      blobTasks.push(
        fetch(originalSrc)
          .then((res) => res.blob())
          .then((blob) => {
            const blobUrl = URL.createObjectURL(blob);
            img.src = blobUrl;
          })
          .catch(() => {})
      );
    });
    await Promise.all(blobTasks);
    const loadWait = Array.from(imgList).map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) resolve();
          img.onload = resolve;
          img.onerror = resolve;
        })
    );
    await Promise.all(loadWait);
    await new Promise((resolve) => setTimeout(resolve, 100));

    const canvas = await html2canvas(dom, {
      useCORS: false,
      allowTaint: false,
      scale: 2,
      backgroundColor: "#ffffff",
      letterRendering: true,
      logging: false,
    });

    // 固定尺寸 宽1242 高2048
    const FIX_W = 1242;
    const FIX_H = 2048;
    const targetCanvas = document.createElement("canvas");
    targetCanvas.width = FIX_W;
    targetCanvas.height = FIX_H;
    const ctx = targetCanvas.getContext("2d");
    // 填充纯白背景
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, FIX_W, FIX_H);

    // 等比例缩放原图，完整放进固定画布
    const srcW = canvas.width;
    const srcH = canvas.height;
    const scale = Math.min(FIX_W / srcW, FIX_H / srcH);
    const drawW = srcW * scale;
    const drawH = srcH * scale;
    // 居中绘制
    const x = (FIX_W - drawW) / 2;
    const y = (FIX_H - drawH) / 2;
    ctx.drawImage(canvas, x, y, drawW, drawH);

    const imgUrl = targetCanvas.toDataURL("image/jpeg", 0.92);
    this.posterDataUrl = imgUrl;

    if (!this.isWechatEnv()) {
      const link = document.createElement("a");
      link.download = `${this.currentShareItem.title}_分享海报.png`;
      link.href = imgUrl;
      link.click();
      Message.success("海报下载成功！");
    } else {
      this.showWechatSaveMask = true;
    }

    restoreSrcList.forEach((lifeInfo) => {
      URL.revokeObjectURL(lifeInfo.el.src);
      lifeInfo.el.src = lifeInfo.src;
    });
  } catch (err) {
    Message.error("海报生成失败，请重试");
    console.error("海报截图异常：", err);
  }
},
    getRandomColor() {
      const randomIndex = Math.floor(Math.random() * this.colors.length);
      return this.colors[randomIndex];
    },
displayDate(date) {
    if (!date) return '';  // ✅ 空值返回空字符串
    return date.split(" ")[0];
},
    async loadPriorityData(id) {
      try {
        await Promise.all([this.searchListByKeyword(id, "id")]);
      } catch (error) {
        console.error("加载关键数据失败:", error);
      }
    },
    // 防抖函数
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    async init() {
      const currentYearMonth = `${new Date().getFullYear()}-${String(
        new Date().getMonth() + 1
      ).padStart(2, "0")}`;
      this.selectMonthValue = currentYearMonth;
      await this.handleToSelectMonth(currentYearMonth, 0);
    },
    async loadMoreReplies(comment) {
      if (comment.loadingMore) return;

      comment.loadingMore = true;
      try {
        const nextPage = comment.replyPage + 1;
        const resp = await getQsList({
          lifeId: this.commLifeId,
          id: comment.id,
          pageNo: nextPage,
          pageSize: this.currentSize,
        });

        if (resp.code === 200) {
          const newReplies = resp.data.data || [];
          comment.replies = [...comment.replies, ...newReplies];
          comment.replyPage = nextPage;
          // 更新是否还有更多回复的状态
          comment.hasMoreReplies = comment.replies.length > comment.replyCount;
        } else {
          Message.error(resp.msg || "加载更多回复失败");
        }
      } catch (error) {
        Message.error("网络错误，请稍后重试");
      } finally {
        comment.loadingMore = false;
      }
    },
    async loadReplies(comment) {
      if (comment.loadingReplies || comment.replies.length > 0) return;

      comment.loadingReplies = true;
      try {
        const resp = await getQsList({
          lifeId: this.commLifeId,
          id: comment.id,
          pageNo: 1,
          pageSize: this.currentSize, // 每次加载5条回复
        });

        if (resp.code === 200) {
          comment.replies = resp.data.data || [];
          comment.replyPage = 1;
          // 判断是否还有更多回复
          comment.hasMoreReplies =
            comment.replies.length >= this.currentSize &&
            comment.replies.length < comment.replyCount;
        } else {
          Message.error(resp.msg || "加载回复失败");
        }
      } catch (error) {
        Message.error("网络错误，请稍后重试");
      } finally {
        comment.loadingReplies = false;
      }
    },
    async loadMoreComments() {
      if (this.currentPage >= this.totalPages) {
        this.hasMore = false;
        return;
      }

      this.loading = true;
      this.currentPage++;

      try {
        const resp = await getQsList({
          id: this.id,
          lifeId: this.commLifeId,
          pageNo: this.currentPage,
          pageSize: this.currentSize,
        });

        if (resp.code === 200) {
          const newComments = resp.data.data || [];
          // 为每个新评论初始化回复相关属性
          newComments.forEach((comment) => {
            comment.replies = [];
            comment.replyPage = 1;
            comment.hasMoreReplies = false;
            comment.loadingReplies = false;
            comment.loadingMore = false;
          });
          this.comments = [...this.comments, ...newComments];

          if (this.currentPage >= resp.data.totalPage) {
            this.hasMore = false;
          }
        } else {
          Message.error(resp.msg || "加载更多失败");
          this.currentPage--;
        }
      } catch (error) {
        Message.error("网络错误，请稍后重试");
        this.currentPage--;
      } finally {
        this.loading = false;
      }
    },
    async openLifeComment(id, title) {
      this.commLifeId = id;
      this.commLifeTitle = title;
      await this.getQsListInfo();
      this.showLifeComment = !this.showLifeComment;
      document.body.style.overflow = "hidden";
      return;
    },
    async getRecentQsListInfo() {
      try {
        const resp = await getRecentQsList();
        if (resp != null && resp.code == 200) {
          this.currCommentList = resp.data;
        }
      } catch (error) {
        Message.error("获取最新留言失败！");
      }
      return;
    },
    async getLifeTypeCountInfo() {
      try {
        const resp = await getLifeTypeListByCount();
        if (resp != null && resp.code == 200) {
          this.tags = resp.data;
        }
      } catch (error) {
        Message.error("加载故事归档失败！");
      }
      return;
    },
    closeLifeComment() {
      this.showLifeComment = !this.showLifeComment;
      document.body.style.overflow = "";
      return;
    },
    toggleFullscreen(url, e) {
      return;
    },
    closeFullscreen() {
      this.isFullscreen = false;
      // 恢复滚动
      document.body.style.overflow = "";
    },
    async handleToSelectItem(value) {
      await this.handleToSelectMonth();
    },
    async searchListByKeyword(value, fieldNameType) {
      this.keyword = value;
      this.fieldName = fieldNameType;
      const SearchQo = {
        pageNo: 1,
        pageSize: this.pagination.limit,
        fieldName: this.fieldName,
        keyword: this.keyword,
      };
      const resp = await getLifeDetail(SearchQo);
      if (resp.data != null) {
        this.lifeInfo = resp.data;
      }
      this.$nextTick(() => {
        if (this.$refs.backtopRef) {
          // 手动触发 backtop 的点击事件
          this.$refs.backtopRef.handleClick();
        }
      });
      this.keyword = value;
      this.fieldName = fieldNameType;
    },
    async getUserInfo() {
      const resp = await getUserInfo({ id: config.BASE_USER_ID });
      this.UserInfo = resp.data;
      this.UserInfo.portrait = config.BASE_FILE_URL + resp.data.portrait;
      this.UserInfo.draw = config.BASE_FILE_URL + resp.data.draw;
      return resp;
    },

    async getQsListInfo() {
      this.loading = true;
      try {
        const resp = await getQsList({
          id: this.id,
          lifeId: this.commLifeId,
          pageNo: 1,
          pageSize: this.currentSize,
        });
        if (resp.code === 200) {
          this.currentPage = 1;
          this.comments = resp.data.data || [];
          this.totalPages = resp.data.totalPage || 1;

          // 初始化每个评论的回复相关属性
          this.comments.forEach((comment) => {
            comment.replies = [];
            comment.replyPage = 1;
            comment.hasMoreReplies = comment.replyCount > 0;
            comment.loadingReplies = false;
            comment.loadingMore = false;
          });

          this.hasMore = this.currentPage < this.totalPages;
        } else {
          Message.error(resp.msg || "获取留言列表失败，请稍后重试");
        }
      } catch (error) {
        Message.error("网络错误，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    async submitComment() {
      if (this.newComment.trim() === "") {
        Message.error("请输入留言内容");
        return;
      }
      if (this.newName.trim() === "") {
        Message.error("请输入昵称");
        return;
      }

      const newComment = {
        parentId: null,
        lifeId: this.commLifeId,
        email: this.commEmail,
        userName: this.newName,
        qsInfo: this.newComment,
      };

      saveCommentsData(newComment)
        .then((resp) => {
          if (resp.code === 200) {
            Message.success("操作成功，感谢您的留言！");
            this.newComment = "";
            this.getQsListInfo(); // 刷新评论列表
          } else {
            Message.error(resp.msg || "留言失败，请稍后重试");
          }
        })
        .catch(() => {
          Message.error("网络错误，请稍后重试");
        });
    },
    showReplyBox(comment, reply = null) {
      this.activeReplyBox = comment.id;
      this.currentReplyTo = reply ? reply.userName : comment.userName;
      this.replyContent = `@${this.currentReplyTo} `;
      this.replyEmail = this.commEmail;

      this.$nextTick(() => {
        this.$refs.replyTextarea.focus();
      });
    },
    submitReply(comment) {
      if (this.replyContent.trim() === "") {
        Message.error("请输入回复内容");
        return;
      }
      if (this.newName.trim() === "") {
        Message.error("请输入昵称");
        return;
      }

      const newReply = {
        parentId: comment.id,
        lifeId: this.commLifeId,
        userName: this.newName,
        email: this.commEmail,
        qsInfo: this.replyContent,
      };
      saveCommentsData(newReply)
        .then((resp) => {
          if (resp.code === 200) {
            Message.success("回复成功！");
            this.replyContent = "";
            this.activeReplyBox = null;
            this.currentReplyTo = null;
            this.getQsListInfo(); // 刷新评论列表
          } else {
            Message.error(resp.msg || "回复失败，请稍后重试");
          }
        })
        .catch(() => {
          Message.error("网络错误，请稍后重试");
        });
    },
    cancelReply() {
      this.activeReplyBox = null;
      this.currentReplyTo = null;
      this.replyContent = "";
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getQsListInfo(); // 刷新评论列表
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getQsListInfo(); // 刷新评论列表
      }
    },
  },
};
</script>

<style scoped>
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: space-between;
  padding: 5px;
  border-radius: 5px;
  width: calc(100% - 10px);
}

.tag-container::after {
  content: "";
  flex: 1;
  min-width: calc(25% - 10px);
  /* 根据每行元素数量调整 */
}

.tag {
  padding: 5px;
  border-radius: 5px;
  color: var(--font-color-1);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
}

.tag:hover {
  background: linear-gradient(135deg, #ff0000, #ff6b6b) !important;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
}

/* 修复后的动画样式 */
.slide-in-left {
  opacity: 0;
  /* 使用margin-left代替transform避免干扰 */
  margin-left: -50px;
  animation: slideInLeftSoft 0.8s ease-out 0.6s forwards;
}

.slide-in-right {
  opacity: 0;
  margin-left: 50px;
  animation: slideInRightSoft 0.8s ease-out 0.6s forwards;
}

@keyframes slideInLeftSoft {
  to {
    opacity: 1;
    margin-left: 0;
  }
}

@keyframes slideInRightSoft {
  to {
    opacity: 1;
    margin-left: 0;
  }
}

/* 滚动加载样式 */
.loading-more {
  text-align: center;
  padding: 20px;
}

.load-more-hint {
  text-align: center;
  padding: 15px;
  font-size: 14px;
}

.no-more {
  text-align: center;
  padding: 20px;
  font-size: 14px;
}

/* 加载更多回复按钮 */
.load-more-replies {
  text-align: center;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

/* 回复信息样式 */
.replies-info {
  margin-left: 50px;
  margin-top: 10px;
}

.reply-count {
  cursor: pointer;
  font-size: 13px;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  justify-content: flex-end;
}

.loading-text {
  font-style: italic;
}

.infinite-list {
  max-height: 230px;
  overflow: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #c0c0c0 #f5f5f5;
  list-style: none;
  padding-left: 5px;
  /* 关键属性：强制显示滚动条 */
  overflow-y: scroll !important;
  -webkit-overflow-scrolling: touch;
  /* 在移动端也显示滚动条 */
  scrollbar-width: auto;
}

/* Webkit浏览器滚动条样式 */
/* Webkit浏览器滚动条样式 */
.infinite-list::-webkit-scrollbar {
  width: 8px;
  /* 确保在移动端也显示 */
  display: block !important;
  -webkit-appearance: initial;
}

.bgc {
  background-color: rgba(255, 255, 255, 0.2);
}

.infinite-list::-webkit-scrollbar-track {
  background: #d9d9d9;
  border-radius: 4px;
}

.infinite-list::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 4px;
  /* 移动端优化 */
  min-height: 40px;
}

.infinite-list::-webkit-scrollbar-thumb:hover {
  background: #a0a0a0;
}

.month-list {
  margin-top: 5px;
}

.fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  /* 完全居中 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998 !important;
  cursor: pointer;
  /* 禁止滚动偏移 */
  overflow: hidden;
}

.fullscreen-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fullscreen-image {
  z-index: 9999 !important;
  /* 限制最大宽高，自动等比缩放 */
  max-width: 80vw !important;
  max-height: 80vh !important;
  width: auto;
  height: auto;
  object-fit: contain;
  cursor: default;
  /* 消除图片默认间距 */
  display: block;
}

.ls-div {
  width: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  margin-top: 20px;
  padding: 10px;
}

.li-title:hover {
  font-weight: 600;
}

.ls-title {
  font-weight: 700;
  font-size: 20px;
  display: flex;
}

.ls-line {
  width: 80px;
  border-bottom: #ff6600 5px solid;
  margin-bottom: 10px;
}

.md-title {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-left: 22px;
}

.cm-title {
  font-size: 20px;
  font-weight: 600;
  width: 100%;
  text-align: center;
  margin-bottom: 5px;
}

.md-div {
  display: flex;
  flex-direction: column;
  margin-top: 25px;
}

.md-img-item {
  display: flex;
  align-items: center;
}

.md-img-div {
  display: flex;
  align-content: center;
  gap: 10px;
  font-size: 16px;
  padding-left: 25px;
}

.md-img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.md-editor {
  min-height: auto !important;
  border-radius: 10px !important;
}

.info-tip {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 表格基础：强制两列等宽 + 居中布局（解决PC非居中） */
::v-deep .markdown-body table {
  table-layout: fixed !important;
  width: 100% !important;
  border-collapse: collapse !important;
  /* 合并边框，避免间距 */
}

/* 强制两列等分 + 内容居中（水平+垂直） */
::v-deep .markdown-body th {
  width: 50% !important;
  padding: 2px !important;
  text-align: center !important;
  /* 水平居中 */
  vertical-align: middle !important;
  /* 垂直居中 */
}

/* 图片填充单元格 + 保持比例 + 居中 */
::v-deep .markdown-body th img {
  display: block !important;
  /* 块级元素，彻底居中 */
  width: 100% !important;
  height: auto !important;
  /* 保持原图比例，不拉伸 */
  margin: 0 auto !important;
  /* 图片自身居中（双重保险） */
  object-fit: contain !important;
  /* 等比例缩放，不裁剪 */
}

.info {
  width: 100%;
  margin-bottom: 20px;
  border-radius: 10px;
  box-shadow:
    7px 7px 10px rgba(0, 0, 0, .9),
    -5px -5px 10px rgba(239, 235, 235, 0.3);
}

.info ::v-deep .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.info ::v-deep .v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  height: auto !important;
  z-index: 0 !important;
}

.info ::v-deep .v-note-show .single-show {
  height: auto !important;
}

.ld-item-year {
  width: 100%;
  margin-top: 10px;
  white-space: pre-line;
}

.rg-title-1 {
  text-align: start;
  font-weight: 600;
  font-size: 18px;
}

.rg-top {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

/* .info .v-note-wrapper .markdown-body .md-editor .shadow{
  box-shadow: none !important;
} */

.info [style*="box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px"] {
  box-shadow: none !important;
  border-top: 1px dashed rgba(255, 255, 255, 0.1) !important;
  border-bottom: none !important;
  border-left: none !important;
  border-right: none !important;
}

.rg-div {
  width: calc(100% - 20px);
  padding: 10px;
  border-radius: 5px;
  position: relative;
  aspect-ratio: 1 / 1;
  /* 确保与图片比例一致 */
  overflow: hidden;
  /* 防止溢出 */
}

.rg-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.ld-info {
  max-width: 30%;
  height: auto;
  border-radius: 5px;
}

.ld-info-div {
  width: 100%;
  height: auto;
  margin: 10px;
}

.v-note-wrapper {
  border: none;
}

.v-note-panel {
  border: none;
}

.click_list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  /* margin-bottom: 20px; */
  padding-top: 20px;
}

.el-carousel__container {
  /*height: 456px;*/
  height: 100% !important;
}

@media only screen and (max-width: 768px) {
  .mbl:hover {
    transform: none !important;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.08);
  }

  .pagination {
    justify-content: space-between !important;
  }

  .pagination button {
    margin: 0 !important;
  }

  .content {
    max-width: 100%;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .left {
    width: 100% !important;
  }

  .right {
    width: 100% !important;
  }

  .comments-container {
    width: 90% !important;
    max-height: 80% !important;
  }

  .comment-form textarea {
    max-height: 200px !important;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .comment-form input {
    width: calc(100% - 14px) !important;
  }

  .submit-btn {
    margin-left: 0 !important;
  }

  /* 针对移动端的额外优化 */
  .infinite-list {
    /* 在移动端使用稍细的滚动条 */
    scrollbar-width: thin;
  }

  .infinite-list::-webkit-scrollbar {
    width: 6px;
  }
}

.left {
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  border-radius: 8px;
}

.right {
  width: 30%;
  border-radius: 2%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  max-width: 100%;
  padding-left: 10%;
  padding-right: 10%;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 60px;
}

.home-div {
  width: 100%;
  min-height: 100vh;
  padding-top: 60px;
  overflow: hidden;
}

.no-scroll {
  overflow: hidden;
}

.comment-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.comments-container {
  overflow-y: auto;
  margin-top: 50px;
  max-height: 80%;
  width: 50%;
  border-radius: 10px;
  padding: 5px;
  z-index: 1001;
}

.comments-container h1 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
}

.comment-form {
  margin-bottom: 5px;
}

.comment-form textarea {
  width: 100%;
  padding: 12px 0 12px 0;
  border: 1px solid #ddd;
  border-radius: 6px;
  resize: vertical;
  font-size: 14px;
  margin-bottom: 10px;
}

.comment-form input {
  width: 100px;
  padding: 7px;
  border: 1px solid #ddd;
  border-radius: 6px;
  resize: vertical;
  font-size: 14px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.comment-form textarea::placeholder,
.comment-form input::placeholder {
  color: var(--font-color-4);
}

.comment-item {
  padding: 5px 0;
  margin-bottom: 5px;
}

.comment-item.unprocessed {
  border-radius: 6px;
  padding: 2px;
}

.comment-header {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.user-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
  object-fit: cover;
}

.username {
  font-weight: bold;
  margin-right: 10px;
}

.comment-time,
.reply-time {
  font-size: 12px;
  margin-right: auto;
}

.reply-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  padding: 2px 8px;
  border-radius: 4px;
}

.reply-btn:hover {
  background-color: #1890ff;
}

.comment-content {
  margin-left: 50px;
  line-height: 1;
}

.replies-container {
  margin-left: 50px;
  margin-top: 15px;
  padding-left: 15px;
}

.reply-item {
  margin-bottom: 5px;
  padding-bottom: 12px;
}

.reply-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.reply-header {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.reply-content {
  margin-left: 50px;
  line-height: 1.5;
}

.toggle-replies {
  margin-top: 10px;
}

.reply-box {
  margin-top: 5px;
  margin-left: 50px;
}

.reply-box textarea {
  width: 100%;
  padding: 12px 0 12px 0;
  border: 1px solid #ddd;
  border-radius: 6px;
  resize: vertical;
  font-size: 14px;
  margin-bottom: 10px;
}

.reply-box input {
  width: 100px;
  padding: 7px;
  border: 1px solid #ddd;
  border-radius: 6px;
  resize: vertical;
  font-size: 14px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.reply-actions {
  display: flex;
  justify-content: flex-end;
}

.submit-btn,
.cancel-btn {
  padding: 6px 15px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  margin-left: 10px;
  /* font-weight: 500; */
}

.submit-btn,
.cancel-btn {
  border: none;
}

.submit-btn:hover,
.cancel-btn:hover {
  background-color: #40a9ff;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.pagination button {
  padding: 6px 12px;
  margin: 0 10px;
  border-radius: 4px;
  cursor: pointer;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 分享按钮样式 */
.share-btn {
  margin-left: auto;
  margin-right: 20px;
  cursor: pointer;
  /* transition: 0.2s; */
}

/* 分享弹窗遮罩 */
.share-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-modal-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

/* 海报卡片主体，白底竖版 */
.poster-card {
  width: 300px;
  height: 600px;
  background: #fff;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

/* 顶部主标题 */
.poster-title-main {
  font-size: 30px;
  color: #995555;
  font-weight: 500;
  font-family: "宋体", serif;
}

/* 英文副标题 */
.poster-title-en {
  font-size: 22px;
  font-style: italic;
  color: #333;
}

/* 文章标题 */
.poster-article-title {
  font-size: 20px;
  color: #222;
  font-weight: 500;
}

/* 海报图片区域 */
.poster-img-wrap {
  width: 100%;
}

.poster-img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  object-position: center;
  border-radius: 4px;
}

.poster-img-empty {
  width: 100%;
  height: 220px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

/* 文字摘要 */
.poster-desc {
  text-indent: 2em;
  font-size: 16px;
  color: #444;
  padding: 2px 0 40px 0;
}

/* 二维码区域 */
.poster-qrcode img {
  width: 100px;
  height: 100px;
  display: block;
}

/* 弹窗底部按钮 */
.share-btn-group {
  display: flex;
  gap: 50px;
}

.download-btn,
.close-btn {
  padding: 6px 6px;
  font-size: 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.download-btn {
  background: #409eff;
  color: #fff;
}

.close-btn {
  background: #666;
  color: #fff;
}

/* 微信保存弹窗样式 */
::v-deep .wechat-save-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.92);
  z-index: 999999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 20px;
}

::v-deep .tip-text {
  color: #fff;
  font-size: 16px;
}

::v-deep .save-poster-img {
  width: 85vw;
  max-width: 360px;
  display: block;
}

::v-deep .close-tip {
  color: #aaa;
  font-size: 13px;
  margin-top: 8px;
}
</style>
